import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { TEAM_RECOGNITION_MONTHLY } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const fetchTeamRecognitionMonthlyTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(TEAM_RECOGNITION_MONTHLY.GET_MONTHLY_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitTeamRecognitionMonthlyFilterData = async (data = array()) => {
  try {
    const response = await POST(TEAM_RECOGNITION_MONTHLY.SUBMIT_MONTHLY_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const generateTeamRecognitionMonthly = async () => {
  try {
    const response = await POST(TEAM_RECOGNITION_MONTHLY.GET_MONTHLY_GENERATE, {});
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Single month row (header): recognition period, labels, etc. */
export const getTeamRecognitionMonthlyById = async (id = "") => {
  try {
    const url = `${TEAM_RECOGNITION_MONTHLY.GET_MONTHLY_DETAILS}/${id}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTeamRecognitionMonthlyDetails = async (id = "") => {
  try {
    const url = `${TEAM_RECOGNITION_MONTHLY.GET_MONTHLY_DETAILS}/${id}/details`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTeamRecognitionMonthlyCandidates = async (incentiveClientDetailsId = "") => {
  try {
    const url = `${TEAM_RECOGNITION_MONTHLY.GET_MONTHLY_DETAILS}/${incentiveClientDetailsId}/candidates`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
